import {
  GET_THONG_BAO,
  GET_THONG_BAO_SUCCESS,
  GET_THONG_BAO_FAILURE,
  GET_LIST_THONG_BAO,
  GET_LIST_THONG_BAO_SUCCESS,
  GET_LIST_THONG_BAO_FAILURE,
  UPDATE_THONG_BAO,
  UPDATE_THONG_BAO_SUCCESS,
  UPDATE_THONG_BAO_FAILURE,
  SHOW_THONG_BAO,
} from "./actionTypes";

export const getListThongBao = (dataSearch) => ({
  type: GET_LIST_THONG_BAO,
  dataSearch,
});

export const getListThongBaoSuccess = (data) => ({
  type: GET_LIST_THONG_BAO_SUCCESS,
  payload: data,
});

export const getListThongBaoFailure = () => ({
  type: GET_LIST_THONG_BAO_FAILURE,
});
export const getThongBao = (dataSearch) => ({
  type: GET_THONG_BAO,
  dataSearch,
});

export const getThongBaoSuccess = (data) => ({
  type: GET_THONG_BAO_SUCCESS,
  payload: data,
});

export const getThongBaoFailure = () => ({
  type: GET_THONG_BAO_FAILURE,
});

export const updateThongBao = (dataSearch) => ({
  type: UPDATE_THONG_BAO,
  dataSearch,
});

export const updateThongBaoSuccess = (data) => ({
  type: UPDATE_THONG_BAO_SUCCESS,
  payload: data,
});

export const updateThongBaoFailure = () => ({
  type: UPDATE_THONG_BAO_FAILURE,
});
export const setShowThongBao = () => {
  return {
    type: SHOW_THONG_BAO,
  };
};
